var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"card-login",attrs:{"title":_vm.$t('contactUsPage.ContactText.title'),"body-class":"text-center","header-tag":"nav"}},[_c('b-card-text',{staticClass:"register-text"},[_vm._v(" "+_vm._s(_vm.$t('contactUsPage.ContactText.text'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }